import { toast } from "react-toastify";

import {
  PostSubscriptionProductsRequestBodyType,
  PostSubscriptionProductsRequestPathParamType,
} from "@intelligems/ig-types/functions/experiments/post-subscription-products";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const postSubscriptionProducts = async (
  payload: ApiRequest<
    PostSubscriptionProductsRequestBodyType,
    PostSubscriptionProductsRequestPathParamType
  >
) => {
  const resp = await api.post<string, PostSubscriptionProductsRequestBodyType>(
    `/v2/experiences/${payload.pathParams.experienceId}/subscription-products`,
    payload.body
  );
  return resp.data;
};

export const usePostSubscriptionProducts = () => {
  return useMutation<
    string,
    Error,
    ApiRequest<
      PostSubscriptionProductsRequestBodyType,
      PostSubscriptionProductsRequestPathParamType
    >,
    any
  >({
    mutationFn: async (data) => postSubscriptionProducts(data),
    onSuccess: () => {
      toast.success(
        `Support has been notified of your subscription products price test!`
      );
    },
  });
};
